import numberFormat from "@shared/factories/src/numberFormat.factory"

export const toConvertStringInArray = (accountNumber, limit) => {
  let arrayNumbers = []
  for (let index = 0; index < limit; index++) {
    let number = accountNumber.slice(index, index + 1)
    arrayNumbers.push(numberFormat().formatForNumber(number))
  }
  return arrayNumbers
}

export default toConvertStringInArray
